import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const ScalaPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.SCALA_PAY}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.SCALA_PAY)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.SCALA_PAY)} alt="scalapay" />
    </Box>
  );
};
